import { vnModule_knockoutJS } from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import {termsOfUse_template} from '../components/templates/termsOfUse_template';
import {header} from './header';

declare var ko: any;
declare var page: any;

export class terms_of_use extends vnModule_knockoutJS{

    protected termsOfUse_template: termsOfUse_template
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string{

        return 'terms_of_use';
    }

    buildContent(): Array<Element>{

        this.termsOfUse_template = new termsOfUse_template('terms_of_use', this.viewModel, this);

        return [this.termsOfUse_template.build()];
    }

    public fillPage(): void{
    }
}



// WEBPACK FOOTER //
// ./js/modules/terms_of_use.ts